export enum breakpoints {
  xs = 0,
  sm = 375,
  md = 600,
  lg = 900,
  xl = 1440
}

export enum color {
  ADMIN_BACKGROUND = "#f4f4f4",
  ALTBLACK = "#373737",
  BLACK = "#231F20",
  BLACK_RGBA = "rgba(1, 1, 1, 0.38);",
  BLUE = "#039BE5",
  BLUEGRAY = "#F5F6FA",
  BLUEGRAY_RGBA = "245, 246, 250, 0.8",
  BROWN = "#B29488",
  CARDGRAY = "#DFDFDF",
  DARKBLUE = "#037DBA",
  DARKERBLUE = "#00689B",
  DARKERGRAY = "#707070",
  DARKGRAY = "#333333",
  DARKGREEN = "#008566",
  DARKPURPLE = "#7B1FA2",
  DARKRED = "#CB1A1A",
  FUSCHIA = "#E91E63",
  GRAPHITE = "#505050",
  GRAY = "#E7E8EC",
  GRAY_PROGESS_BAR = "#D3D2D2",
  GREEN = "#00B288",
  ICON = "#F4F4F4",
  INDEX_BG = "#F4F4F4",
  INDEX_FOOTNOTE = "#646464",
  LIGHTBLUE = "rgba(3, 125, 186, 0.1)",
  LIGHTBROWN = "#F3EFED",
  LIGHTERGRAY = "#B9B9B9",
  LIGHTGRAY = "#5F5F5F",
  LIGHTGREEN = "rgba(0, 178, 136, 0.1)",
  LIGHTORANGE = "#FDF2E5",
  LIGHTPURPLE = "rgba(123, 31, 162, 0.1)",
  LIGHTRED = "rgba(255, 82, 82, 0.1)",
  MUTEDGRAY = "#DFDFDF",
  ORANGE = "#F7C07E",
  PALEBLUE = "#EFF9FF",
  PALEGRAY = "#A4A4A4",
  PILLAR_COGNITION = "#7B1FA2",
  PILLAR_DAILY_LIFE = "#E91E63",
  PILLAR_INTERACTION = "#BB8D00",
  PILLAR_WELL_BEING = "#009688",
  PURPLE = "#7B1FA2",
  RED = "#E91E63",
  SLIDERGRAY = "#B9B9B9",
  Theme1 = "#FFF6D7",
  Theme10 = "#68B1D6",
  Theme2 = "#EAF5E4",
  Theme3 = "#F9DBDB",
  Theme4 = "#E5D2EC",
  Theme5 = "#CDE5F1",
  Theme6 = "#FFE387",
  Theme7 = "#BFE0AF",
  Theme8 = "#EE9494",
  Theme9 = "#B079C7",
  WHITE = "#FFF",
  YELLOW = "#FFCA28"
}

export const themeColor: Record<number, color> = {
  1: color.Theme1,
  2: color.Theme2,
  3: color.Theme3,
  4: color.Theme4,
  5: color.Theme5,
  6: color.Theme6,
  7: color.Theme7,
  8: color.Theme8,
  9: color.Theme9,
  10: color.Theme10
};

export const abstractionThemeColor: Record<number, color> = {
  1: color.Theme1,
  2: color.Theme1,
  3: color.Theme5,
  4: color.Theme5,
  5: color.Theme7,
  6: color.Theme7
};

export enum spacingDefaults {
  auto = "auto",
  xsmall = "0.5rem",
  small = "0.75rem",
  normal = "1rem",
  medium = "1.25rem",
  large = "1.75rem",
  xlarge = "2.25rem",
  xxlarge = "4rem"
}

export const addOpacity = (color: color, opacity: number): string => {
  const opacityValue = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + opacityValue.toString(16).toUpperCase();
};

export const backgroundImageStyle = (url: string): string => {
  const backgroundImage = url && `background-image: url(${url})`;
  return `
    ${backgroundImage};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  `;
};

export const spacing = (
  top: spacingDefaults,
  right: spacingDefaults = top,
  btm: spacingDefaults = top,
  left: spacingDefaults = right
): string => {
  return `
    ${top || 0}
    ${right || 0}
    ${btm || 0}
    ${left || 0}
  `;
};

export enum fontFamily {
  primary = "Museo Sans, museo-sans, sans-serif",
  secondary = "Mercury Display, mercury-display, sans-serif"
}

export enum fontSize {
  xsmall = ".75rem",
  small = ".875rem",
  normal = "1rem",
  medium = "1.15rem",
  large = "1.5rem",
  header = "2.25rem",
  xlarge = "2.5rem",
  xxlarge = "3rem"
}

export enum iconSizes {
  xsmall = "0.65rem",
  smaller = "1rem",
  small = "1.5rem",
  normal = "2rem",
  large = "2.5rem",
  xlarge = "3rem"
}

export enum appearances {
  PRIMARY = color.BLUE,
  SUCCESS = color.GREEN,
  WARNING = color.YELLOW,
  ERROR = color.RED
}
